var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRefreshCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.998C17.4706 21.998 22 17.4588 22 11.998C22 6.52746 17.4608 1.99805 11.9902 1.99805C6.52941 1.99805 2 6.52746 2 11.998C2 17.4588 6.53922 21.998 12 21.998ZM8.45098 8.85099C8.10784 8.48824 8.21569 7.97844 8.68628 7.61569C9.53922 6.90981 10.7647 6.47844 11.9902 6.47844C14.902 6.47844 17.1667 8.51765 17.5196 11.4098H18.1863C18.5784 11.4098 18.6863 11.7922 18.451 12.0863L17.1176 13.7726C16.8627 14.0961 16.5 14.0667 16.2647 13.7726L14.902 12.0863C14.6667 11.802 14.7745 11.4098 15.1667 11.4098H16.0686C15.7745 9.50785 14.0588 8.02746 11.9902 8.02746C11.0392 8.02746 10.3333 8.32158 9.62745 8.8706C9.23529 9.16471 8.79412 9.22354 8.45098 8.85099ZM5.4902 11.851L6.82353 10.1647C7.07843 9.84118 7.44118 9.8706 7.67647 10.1647L9.03922 11.851C9.27451 12.1353 9.16667 12.5373 8.77451 12.5373H7.93137C8.22549 14.4294 9.94118 15.9196 12.0098 15.9196C12.9608 15.9196 13.6667 15.6157 14.3726 15.0667C14.7647 14.7824 15.2059 14.7137 15.549 15.0863C15.8922 15.449 15.7843 15.9588 15.3137 16.3314C14.4608 17.0373 13.2353 17.4588 12.0098 17.4588C9.09804 17.4588 6.83333 15.4196 6.48039 12.5373H5.7549C5.36275 12.5373 5.2549 12.1451 5.4902 11.851Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRefreshCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-refresh-circle.880c0579db6992fcc0b5758a0213ff18.svg";